export type ClientErrorIdPrefix = "API" | "ERR" | "ROUTE" | "TOAST";

const randomIdStart = 2;
const randomIdEnd = 9;
const RANDOM_ID_RADIX = 36;

export function createClientErrorId(prefix: ClientErrorIdPrefix = "ERR"): string {
  return `${prefix}-${Date.now()}-${Math.random().toString(RANDOM_ID_RADIX).substring(randomIdStart, randomIdEnd).toUpperCase()}`;
}
